import api from './api';

const subscriptionService = {
  // === GESTION DES FORMULES D'ABONNEMENT ===

  // Récupérer toutes les formules d'abonnement
  getSubscriptionPlans: async (params = {}) => {
    try {
      const response = await api.get('/formules', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des formules d\'abonnement:', error);
      throw error;
    }
  },

  // Créer une formule d'abonnement
  createSubscriptionPlan: async (planData) => {
    try {
      const response = await api.post('/formules', planData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la formule d\'abonnement:', error);
      throw error;
    }
  },

  // Modifier une formule d'abonnement
  updateSubscriptionPlan: async (id, planData) => {
    try {
      const response = await api.put(`/formules/${id}`, planData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification de la formule d\'abonnement:', error);
      throw error;
    }
  },

  // Supprimer une formule d'abonnement
  deleteSubscriptionPlan: async (id) => {
    try {
      const response = await api.delete(`/formules/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la formule d\'abonnement:', error);
      throw error;
    }
  },

  // === GESTION DES ABONNEMENTS UTILISATEURS ===

  // Récupérer tous les abonnements
  getSubscriptions: async (params = {}) => {
    try {
      const response = await api.get('/abonnements', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des abonnements:', error);
      throw error;
    }
  },

  // Attribuer un abonnement à un utilisateur (ADMIN seulement)
  createSubscription: async (subscriptionData) => {
    try {
      const response = await api.post('/abonnements', subscriptionData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'attribution de l\'abonnement:', error);
      throw error;
    }
  },

  // Souscrire à une formule (pour les utilisateurs)
  subscribeToPlan: async (subscriptionData) => {
    try {
      // console.log('Envoi de la requête de souscription:', subscriptionData);
      const response = await api.post('/abonnements/subscribe', subscriptionData);
      // console.log('Réponse de souscription:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la souscription:', error);
      console.error('Détails de l\'erreur:', error.response?.data);
      // Propager l'erreur avec le message du backend si disponible
      if (error.response?.data?.message) {
        error.message = error.response.data.message;
      }
      throw error;
    }
  },

  // Récupérer l'abonnement actif de l'utilisateur connecté
  getMySubscription: async () => {
    try {
      const response = await api.get('/abonnements/my-subscription');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'abonnement:', error);
      throw error;
    }
  },

  // Modifier le statut d'un abonnement (utilise toggle-statut pour basculer entre inactif/actif/expiré)
  toggleSubscriptionStatus: async (id) => {
    try {
      const response = await api.patch(`/abonnements/${id}/toggle-statut`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du statut de l\'abonnement:', error);
      throw error;
    }
  },

  // Modifier le statut d'un abonnement (ancienne méthode, conservée pour compatibilité)
  updateSubscriptionStatus: async (id, statut) => {
    try {
      const response = await api.patch(`/abonnements/${id}/toggle-statut`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du statut de l\'abonnement:', error);
      throw error;
    }
  },

  // Modifier un abonnement
  updateSubscription: async (id, subscriptionData) => {
    try {
      const response = await api.put(`/abonnements/${id}`, subscriptionData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification de l\'abonnement:', error);
      throw error;
    }
  },

  // Supprimer un abonnement
  deleteSubscription: async (id) => {
    try {
      const response = await api.delete(`/abonnements/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'abonnement:', error);
      throw error;
    }
  }
};

export { subscriptionService };
